/**
 * BubbleCommon组件得公共文案
 */
import React from 'react';
import { TipsMapFunType, TipsMapType } from '../index';

export const overviewNegativeTips: TipsMapType = {
  en: (
    <>
      <strong>Calculation method:</strong> <br />
      <strong>Negative topic: </strong> After classifying all mentions by topic,
      calculate the mentions and sentiment score of each topic. Topics with an
      sentiment score lower than 2.5 are negative topics, which are shown in the
      bar chart below.
      <br />
      <strong>Negative keywords: </strong>After classifying all mentions by
      keywords, calculate the mentions and sentiment score of each keyword.
      Keywords with an sentiment score lower than 2.5 are negative keywords,
      which are shown in the word cloud map below.
    </>
  ),
  zh: (
    <>
      <strong>计算规则：</strong>
      <br />
      <strong>负面话题：</strong>
      将所有声量按话题分类后，计算各个话题的声量及情感分。情感分低于 2.5
      的话题为负面话题，显示在下方柱状图中。
      <br />
      <strong>负面关键词：</strong>
      将所有声量按关键词分类后，计算各个关键词的声量及情感分。情感分低于 2.5
      的关键词为负面关键词，显示在下方词云图中。
    </>
  ),
};

export const overviewPositiveTips: TipsMapType = {
  en: (
    <>
      <strong>Calculation method:</strong>
      <br />
      <strong> Positive topic:</strong> After classifying all mentions by topic,
      calculate the mentions and sentiment score of each topic. Topics with an
      sentiment score higher than 3.5 are positive topics, which are shown in
      the bar chart below.
      <br />
      <strong> Positive keywords: </strong> After classifying all mentions by
      keywords, calculate the mentions and sentiment score of each keyword.
      Keywords with an sentiment score higher than 3.5 are positive keywords,
      which are shown in the word cloud map below.
    </>
  ),
  zh: (
    <>
      <strong>计算规则：</strong>
      <br />
      <strong>正面话题：</strong>
      将所有声量按话题分类后，计算各个话题的声量及情感分。情感分高于 3.5
      的话题为正面话题，显示在下方柱状图中。
      <br />
      <strong>正面关键词：</strong>
      将所有声量按关键词分类后，计算各个关键词的声量及情感分。情感分高于 3.5
      的关键词为正面关键词，显示在下方词云图中。
    </>
  ),
};

export const overviewEmergingTips: TipsMapType = {
  en: (
    <>
      <strong>Emerging Topic&Keywords：</strong>
      <br />
      Keywords that appear in the last hour, but haven't appeared in the last 3
      or 5 days (Days of Game Store/ Monitoring Keywords/ Monitor Accounts are
      different), as Emerging keywords . Here are the top 20 Emerging Keywords
      in terms of Mentions, and topics aggregated based on these keywords.
    </>
  ),
  zh: (
    <>
      <strong>突发话题&关键词:</strong> <br />
      统计过去 1 个小时出现，但是过去 3 天或者 5
      天没出现过的关键词（商店、监控关键词、监控官号来源的周期天数不同），作为游戏突发的关键词。此处展示前20个突发关键词，并根据这些关键词聚合成突发话题。
    </>
  ),
};

export const overviewTopicTips: TipsMapType = {
  en: (
    <>
      The topic sum here is the sum of the mentions of all topics in the
      selected time period, without reviews deduplication, and it is different
      from the total number of reviews of the labeled topics.
    </>
  ),
  zh: (
    <>
      此处话题总和为所选时段所有话题的声量之和，未经评论去重处理，因此与被标记话题的评论总数不同。
    </>
  ),
};

export const overviewMapTips: TipsMapType = {
  en: (
    <>
      The label 'Unidentified' represents reviews that cannot distinguish
      region/country.
    </>
  ),
  zh: <>无法区分地区/国家的评论。</>,
};

export const overviewKeywordTips: TipsMapType = {
  en: (
    <>
      Merged synonyms are displayed in English: The keywords shown below use
      keyword extraction and integration technology, which supports merging and
      counting the mentions of synonyms across languages. Since this technology
      is mainly operable and improvable in English, the merged keywords will be
      displayed in English basically. However, clicking on the English words
      will take you to the details page, which will show the original language
      (such as Japanese) reviews of the keyword.
      <br />
      Search keywords by keyword filter: Only supports searching original
      keywords, and the mentions statistics do not include all synonyms of the
      word.
    </>
  ),
  zh: (
    <>
      合成词默认显示为英文：下方展示的关键词采用了关键词提取及整合技术，支持将跨语种的同义词（简称合成词）声量合并统计。该技术主要基于英文，因此此处展示的合成词都将以英文显示为主。但是点击这些英语单词，进入的评论详情页将显示该关键词的源语种（如日语）评论。
      <br />
      通过关键词筛选器搜索关键词：仅支持搜索原始关键词，其声量统计不包括该词涉及的所有同义词。
    </>
  ),
};

export const intelligenceMapTips: TipsMapType = {
  en: "View the game's KPIs performing",
  zh: '查看游戏KPI数据表现',
};

export const dashboardDisabledMapTips: TipsMapFunType = (isGlobal: boolean) => {
  if (isGlobal) {
    return {
      en: <>Please contact the P Team to apply for the required permissions</>,
      zh: <>请联系P Team申请经分权限</>,
    };
  }

  return {
    en: (
      <>
        Please go to the sensitive authority system to apply the game access:
        <a href="https://appauth.intlgame.com" target="_blank">
          https://appauth.intlgame.com
        </a>
      </>
    ),
    zh: (
      <>
        请到敏感权限系统申请经分权限:
        <a href="https://appauth.intlgame.com" target="_blank">
          https://appauth.intlgame.com
        </a>
      </>
    ),
  };
};

export const dashboardMapTips: TipsMapType = {
  en: 'Dashboard: View the performance data of your games.',
  zh: '查看自己的游戏数据表现。',
};
